import { FC } from 'react';
import { suggestedBrokers } from './config';
import _ from 'lodash';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { useResponsive } from 'v3/common/hooks/useResponsive';

const SuggestedBrokers: FC<{ handlePreviouslyLoggedInBroker: (brokerId?: string) => void }> = ({
  handlePreviouslyLoggedInBroker,
}) => {
  const isMobile = useResponsive();
  return (
    <section className="suggested-broker-logos">
      <div className="broker-logos-container">
        {_.map(suggestedBrokers, (broker) => (
          <OverlayTrigger
            key={broker.id}
            placement="top"
            trigger={isMobile ? [] : ['hover', 'focus']}
            overlay={
              <Tooltip className="suggested-broker-tooltip" id={`tooltip-${broker.id}`}>
                {_.upperCase(broker.id)}
              </Tooltip>
            }
          >
            <div className="card" onClick={() => handlePreviouslyLoggedInBroker(broker.id)}>
              <img src={broker.img} alt={broker.id} />
            </div>
          </OverlayTrigger>
        ))}
      </div>
      <button className="broker-logos-btn" onClick={() => window.openLoginModal()}>
        +35 More
      </button>
    </section>
  );
};

export default SuggestedBrokers;
